export const APP_ENVIRONMENT = process.env.REACT_APP_DEPLOY_ENV!;

export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
export const SPLIT_AUTHORIZATION_KEY = process.env.REACT_APP_SPLIT_AUTHORIZATION_KEY!;
export const SPLIT_KEY = 'skyweb';

// Sentry deny urls as arrays of RegExps
export const SENTRY_DENY_URLS = (process.env.REACT_APP_SENTRY_DENY_URLS || '')
  .split(',')
  .filter(s => !!s)
  .map(s => new RegExp(s, 'i'));

export const AUTH0_CONFIG: any = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  scope:
    'openid profile email https://idm.sky.co.nz/profile_id https://idm.sky.co.nz/account_id https://idm.sky.co.nz/email_address https://idm.sky.co.nz/customer_group_type',
  audience: process.env.REACT_APP_AUTH0_AUDIENCE,
};
export const SALESFORCE_SALES_SCRIPT_SRC = process.env.REACT_APP_SF_SALES_SCRIPT_SRC!;
export const SALESFORCE_SALES_DEPLOYMENT_NAME = process.env.REACT_APP_SF_SALES_DEPLOYMENT_NAME!;
export const REACT_APP_SF_SALES_CHAT_URL = process.env.REACT_APP_SF_SALES_CHAT_URL!;

export const SALESFORCE_LIVE_SCRIPT_SRC = process.env.REACT_APP_SF_LIVE_SCRIPT_SRC!;
export const SALESFORCE_LIVE_DEPLOYMENT_NAME = process.env.REACT_APP_SF_LIVE_DEPLOYMENT_NAME!;
export const SALESFORCE_LIVE_CHAT_URL = process.env.REACT_APP_SF_LIVE_CHAT_URL!;

export const SALESFORCE_CHAT_ORG_ID = process.env.REACT_APP_CHAT_SF_ORG_ID!;
export const SALESFORCE_CHAT_SCRT2_URL = process.env.REACT_APP_CHAT_SF_SCRT2_URL!;

export const PrivacyPolicyURL = process.env.REACT_APP_PRIVACY_POLICY_URL;
export const ConsumerTermsURL = process.env.REACT_APP_CONSUMER_TERMS_URL;

export const FooterCustomLogo = process.env.REACT_APP_FOOTERCUSTOMLOGO;

export const ADDRESS_SERVICE_URL = process.env.REACT_APP_ADDRESS_LOOKUP_ENDPOINT!;

export const ADDRESS_PREQUAL_ENDPOINT = process.env.REACT_APP_ENDPOINT!;

export const REACT_APP_ENDPOINT = process.env.REACT_APP_ENDPOINT!;

export const DOMAIN = process.env.REACT_APP_DOMAIN!;

export const JSON_CONFIG_URL = process.env.REACT_APP_JSON_CONFIG_URL;
export const REACT_APP_MSL_CT_ENDPOINT = process.env.REACT_APP_MSL_CT_ENDPOINT!;
export const PURCHASE_JOURNEY_CONTENT_ID = 'purchase-journey-nbj';
export const PURCHASE_JOURNEY_CONTENT_URL = `${REACT_APP_ENDPOINT}/my-account/static-json?contentId=${PURCHASE_JOURNEY_CONTENT_ID}`;
export const PURCHASE_JOURNEY_CONTENT_FIELD_NAME = 'content';
// export const REACT_APP_MSL_CT_ENDPOINT='https://apiv3.shared-prelive.skycloud.co.nz/commerce-tools-integration';

// CommerceTools API Authentication Tokens
export const REACT_APP_CT_TOKEN_1 = process.env.REACT_APP_CT_TOKEN_1 || '';
export const REACT_APP_CT_TOKEN_2 = process.env.REACT_APP_CT_TOKEN_2 || '';
export const REACT_APP_CT_CHANNEL_TOKEN = process.env.REACT_APP_CT_CHANNEL_TOKEN || '';
/** Channel logo list used in Liferay as well. */
export const CHANNEL_JSON_CONFIG_URL =
  'https://static.sky.co.nz/sky/json/channel_accordion_channel_logo_list.json';
export const CHANNELS_JSON_CONFIG_URL =
  'https://skywebconfig.msl-prod.skycloud.co.nz/sky/json/channels.prod.json';

/* Coupon codes like these should be in envkey to avoid redeployment on change. */
export const boxCampaigns = process.env.REACT_APP_BOX_CAMPAIGNS
  ? JSON.parse(process.env.REACT_APP_BOX_CAMPAIGNS)
  : [];

export const IS_CAPTCHA_ENABLED = process.env.REACT_APP_CAPTCHA_ENABLED! === '1';

export const IdealActiveDate = {
  broadbandNewInstallationLeadDays: 10,
  broadbandDIYActivationLeadDays: 5,
  broadbandVoiceDefaultLeadDays: 2,
  broadbandBYODDefaultLeadDays: 1,
};
